define.alias("ember-math-helpers/helpers/tan", "media/helpers/tan");